window.subscriptionFlow = {
    currentVariantId: null,
    sellingPlanId: null,
    productId: null,
    productSKU: null,
    productTitle: null,
    boxSequence: null,
    subscriptionSku: null,
    productType: null,
    originUrl: null,
};

class SubscriptionFunnel {
    constructor(container, isCart = false) {
        this.funnel = container;
        this.isHackpack = container?.getAttribute('data-subscription-funnel-hackpack');
        this.interacted = 0;
        this.isCamp = container?.getAttribute('data-subscription-funnel-camp');
        if (this.funnel) {
            this.isCart = isCart;

            this.funnel.querySelectorAll("[data-subscriptionProduct]").forEach(ele =>
                ele.addEventListener("click", (event) => {
                    event.stopImmediatePropagation();
                    this._getSubscriptionDetails(event);       
                })
            )

            this.funnel.querySelectorAll("[open-subscription-popup]").forEach(ele =>
                ele.addEventListener("click", (event) => {
                    event.preventDefault();
                    if (window.subscriptions.enable_sub_limit) {
                        let quantityCount = 0;
                        window.globalVariables.cart.items.forEach(item => {
                            if (item.product_type === "Build a Box Subscription") {
                                quantityCount = quantityCount + item.quantity;
                            }
                        });

                        if (quantityCount >= window.subscriptions.product_limit) {
                            ele.closest("[data-product-form]")
                                ?.querySelector(".subscription_limit_error_msg")
                                .classList.remove("d-none");
                            return false;
                        }
                    }

                    ele.closest("[data-product-form]")
                        ?.querySelector(".subscription_limit_error_msg")
                        .classList.add("d-none");

                    this._openPopup(event);
        
                })
            );

            this.funnel.querySelectorAll("[add-subscription-product]").forEach(ele =>
                ele.addEventListener("click", (event) => {
                    event.preventDefault();
                    let type = event.currentTarget.getAttribute("type");
                    let pageType = document.querySelector('[data-box-type]').getAttribute('data-box-type');
                    type === 'direct'
                      ? [this._addToCart(type, event, true),sessionStorage.setItem(`${pageType}`, "1")]
                      : this._addToCart(type, event);
                })
            );

            this.funnel.querySelectorAll("[add-subscription-productcheckout]").forEach(ele =>
              ele.addEventListener("click", (event) => {
                  event.preventDefault();
                  let currentEvent = event;
                  let type = event.currentTarget.getAttribute("procedure");
                  let popupShow = event.currentTarget.getAttribute('data-show-popup');
                  let popupEnabled = document.querySelector('[data-upsell-popup]').getAttribute('data-upsell-popup');
                  let interacted = event.currentTarget.getAttribute('data-interacted');
                  let dataSubscription = document.querySelector('[data-add-subscription]').closest('.product-popup').querySelector('[add-subscription-product]');
                  let continueBtn = document.querySelector('[data-add-subscription]').closest('.product-popup').querySelector('[data-continue]');
                  let pageType = document.querySelector('[data-box-type]').getAttribute('data-box-type');
                  popupShow === 'true' && interacted === 'true' && sessionStorage.getItem(`${pageType}`) !== '1' && popupEnabled === 'true'
                    ? [this._openPopupUpsell(type, event),dataSubscription.dataset.upsellValue = `Upsold from ` + document.querySelector('.tablink.active .sub-plan.fw-medium.text-black').innerText, continueBtn.dataset.continue = `Continued purchase from ` + document.querySelector('.tablink.active .sub-plan.fw-medium.text-black').innerText]
                    : this._addToCart(type, currentEvent);
              })
          );


            if (!this.isCart) {
                this._selectedProduct();
            }
        }
    };

    _selectedProduct() {
        const _this = this;
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('product-handle')) {
            _this.funnel.querySelectorAll("[data-subscriptionProduct]").forEach(ele => {
                let handle = ele.getAttribute("data-subscriptionProduct");
                if (handle === urlParams.get('product-handle')) {
                    ele.click();
                    this.interacted++;
                }
            });
        } else {
            this.funnel.querySelectorAll('.subscription-main').forEach(subMain => {
                subMain.querySelectorAll("[data-subscriptionProduct]")[0].click();
                this.interacted++;
            });
        }
    }

    _getSubscriptionDetails(event) {
        let currentElement = event.currentTarget;
        currentElement.parentNode.parentNode.querySelectorAll(
            "[data-subscriptionProduct].active"
        ).forEach(ele => {
          if(currentElement !== ele && this.interacted === 2) {
            this.interacted = 2;
            document.querySelectorAll('[data-interacted]').forEach(item => item.setAttribute('data-interacted', true));
          }
            ele.classList.remove("active");
        });
        currentElement.classList.add("active");

        if (!this.isCart) {
            const url = new URL(window.location.href); // TODO: uncomment this when global.js.liquid line 1255 is done
            const searchParams = url.searchParams;
            searchParams.set("product-handle", currentElement.getAttribute('data-subscriptionProduct'));
            document.querySelector('.subscription-camp')
              ? null
              : document.querySelector('meta[property="og:price:amount"]')?.setAttribute('content', currentElement.querySelector('[data-price-attr]')?.getAttribute('data-price-attr'));
            url.search = searchParams.toString();
            const newUrl = url.pathname + url.search;
            window.history.replaceState({}, '', newUrl);
        }

        let formSelector = currentElement.getAttribute('data-formcontent');
        let productForm = this.funnel.querySelector(formSelector);
        subscriptionFlow.currentVariantId = productForm?.querySelector('[name="id"]')?.value;
        subscriptionFlow.sellingPlanId = productForm?.querySelector('[name="selling_plan"]')?.value;
        subscriptionFlow.productType = productForm?.querySelector('[data-product-type]')?.value || null;
        subscriptionFlow.preorder = productForm?.querySelector('[name="preorder"]')?.value || null;
        subscriptionFlow.originUrl = productForm?.querySelector('[name="origin_url"]')?.value || null;
        // subscriptionFlow.subscriptionSku = productForm.querySelector('[name="subscription_sku"]').value;
        if (window.subscriptions.enable_box_sequence) {
            /* new way */
            window.boxSequenceApi.getBoxSequenceProperties().then(result => {
                window.subscriptionFlow = result;
            });
        } else {
            /* old way */
            subscriptionFlow.productId = productForm?.querySelector('[name="product_id"]')?.value;
            subscriptionFlow.productSKU = productForm?.querySelector('[name="product_sku"]')?.value;
            subscriptionFlow.productTitle = productForm?.querySelector('[name="product_title"]')?.value;
        }
    };

    _openPopup(event) {
        let form = event.currentTarget.closest("form");
        let quantity = parseInt(form.querySelector("[data-quantity-value]").value);
        this.funnel.querySelector("[data-subscriber-info]").innerHTML = "";
        let finalHtml = "";

        if (quantity === 1) {
            this.funnel.querySelector("[data-subscription-modal]").classList.add("single-subscription");
        } else {
            document.querySelector("[data-subscription-modal]").classList.remove("single-subscription");
        }

        for (let index = 1; index <= quantity; index++) {
            let html = `
            <form data-subscriber-form>
            <div data-subscriber-details>
                <h6 class="font-size-lg text-uppercase mb-2 pb-1">SUBSCRIPTION #${index}</h6>
                <div class="form-floating name-label mb-3">
                    <input type="text" id="fname_${index}" name="fname" class="form-control" placeholder="Name" required data-nickname>
                    <label class="w-100 d-flex justify-content-between" for="fname_${index}"><div class="me-2">Name<span class="text-gray-700 fw-normal ms-1">(or nickname!)</span></div><span class="text-gray-700 fw-normal label-optional">required*</span></label>
                </div>

                <div class="form-floating birthday-label mb-3 mb-lg-3">
                    <input type="text" id="datepicker_${index}" name="birthdate" class="form-control" placeholder="Their Birthday" data-birthdate> 
                    <label for="datepicker_${index}"><div class="me-2">Their Birthday<span class="text-gray-700 fw-normal ms-1">(MM/DD/YYYY)</span></div><span class="text-gray-700 fw-normal label-optional">${window.subscriptions.birthday_required ? 'required*' : 'optional*' }</span></label>
                    <p class="mt-1 subscription-quantity font-size-xs fst-italic">${window.subscriptions.optional_text}</p>
                </div>
            </div> 
            </form>`
            finalHtml = finalHtml + html;
        }
        this.funnel.querySelector("[data-subscriber-info]").innerHTML = finalHtml;
        this.funnel.querySelector("[data-subscription-modal]").classList.add("open");
        this.funnel.querySelectorAll("[data-birthdate]").forEach(ele => {
            ele.addEventListener("change", (ele) => {
                this._checkBirthDate();
            })
        })

        siteOverlay.prototype.showOverlay();
        this._flatPickerTrigger();

        this.funnel.querySelectorAll("[data-subscriber-details]").forEach(ele => {
            ele.addEventListener("keyup", (ele) => {
                this._checkInputValue();
            })
        })
    }
    _openPopupUpsell(type, event) {
      let form = event.currentTarget.closest("form");
      let quantity = parseInt(form.querySelector("[data-quantity-value]").value);
      let pageType = document.querySelector('[data-box-type]').getAttribute('data-box-type');
      let continueBtn = document.querySelector('[data-add-subscription]');
      continueBtn.addEventListener('click', (e) => {
        continueBtn.classList.add('loading');
        sessionStorage.setItem(`${pageType}`, "1");
        this._addToCart(type, event);
      })


      this.funnel.querySelector("[data-subscriber-info]").innerHTML = "";
      let finalHtml = "";

      if (quantity === 1) {
          this.funnel.querySelector("[data-subscription-modal]").classList.add("single-subscription");
      } else {
          document.querySelector("[data-subscription-modal]").classList.remove("single-subscription");
      }

      this.funnel.querySelector("[data-subscriber-info]").innerHTML = finalHtml;
      this.funnel.querySelector("[data-subscription-modal]").classList.add("open");
      this.funnel.querySelectorAll("[data-birthdate]").forEach(ele => {
          ele.addEventListener("change", (ele) => {
              this._checkBirthDate();
          })
      })

      siteOverlay.prototype.showOverlay();
      this._flatPickerTrigger();

      this.funnel.querySelectorAll("[data-subscriber-details]").forEach(ele => {
          ele.addEventListener("keyup", (ele) => {
              this._checkInputValue();
          })
      })
    }

    _checkBirthDate() {
        let flag = false;
        this.funnel.querySelectorAll("[data-birthdate]").forEach(ele => {
            if ((this._dateMethods(new Date())) < (new Date(ele.value))) {
                flag = true;
            }
        });
        if (flag) {
            this.funnel.querySelector("[data-child-info]").classList.remove("d-none");
        } else {
            this.funnel.querySelector("[data-child-info]").classList.add("d-none");
        }
    };

    _dateMethods(date) {
        return new Date(date.setFullYear(date.getFullYear() - parseInt(5)));
    }

    _checkInputValue() {
        let formInvalid = false;
        this.funnel.querySelectorAll("[data-nickname]").forEach(ele => {
            let inputValue = ele.value.trim();
            if (!inputValue || inputValue.length <= 0) {
                formInvalid = true;
            }
        });

        if(window.subscriptions.birthday_required) {
          this.funnel.querySelectorAll("[data-birthdate]").forEach(ele => {
            let inputValue = ele.value.trim();
            if (!inputValue || inputValue.length <= 0) {
                formInvalid = true;
            }
          });
        }

        if (formInvalid) {
            this.funnel.querySelectorAll("[add-subscription-product]").forEach(ele => {
                ele.setAttribute("disabled", 'true');
            })
        } else {
            this.funnel.querySelectorAll("[add-subscription-product]").forEach(ele => {
                ele.removeAttribute("disabled");
            })
        }
    }

    _flatPickerTrigger() {
        this.funnel.querySelectorAll("[data-birthdate]").forEach(ele => {
            flatpickr(ele, {
                allowInput: true,
                altInput: true,
                maxDate: "today",
                dateFormat: "Y-m-d",
                disableMobile: true,
                parseDate: (datestr, format) => {
                    return new Date(datestr.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
                },
                onReady: (selectedDates, dateStr, instance) => {
                    console.log(instance)
                },
                onClose: (() => {
                  this._checkInputValue();
                })
            });
        });
    }

    _pixelsEvent(addedItems) {
        try {
            const subHandle = this.funnel.querySelector(`.tab-pane.tabcontent.open [name="subscription_handle"]`),
                mainHandle = this.funnel.querySelector('#landing-subscription-product-handle');
            addedItems.map(addedItem => {
                const qtyAdded = parseFloat(addedItem.quantity);
                fetch(`${window.location.origin}/products/${subHandle.value}.json`)
                    .then(res => res.clone().json().then(r => {
                        if (r.product) {
                            const product = r.product;
                            let atcEventData = {
                                name: `${product.title}`,
                                productID: product.id,
                                url: `${window.location.origin}/products/${mainHandle.value}?product-handle=${product.handle}`,
                                imageURL: product.image ? product.image.src : '',
                                price: `$${product.variants[0].price}`,
                                compareAtPrice: `${product.variants[0].compare_at_price ? `$${product.variants[0].compare_at_price}` : ''}`,
                                brand: product.vendor,
                                categories: product.product_type,
                            }

                            //klaviyo
                            let _learnq = window.klaviyo || [];
                            _learnq.push(['track', 'Added to Cart', atcEventData]);
                            console.log(`klaviyo Added to Cart data:`);
                            console.log(atcEventData);

                            //bing
                            const bingEventData = {
                                ecomm_prodid: [atcEventData.productID],
                                ecomm_pagetype: 'product',
                                currency: 'USD',
                                event_category: atcEventData.categories,
                                event_label: atcEventData.name,
                                event_value: parseFloat(product.variants[0].price),
                                items: [
                                    {
                                        id: atcEventData.productID,
                                        quantity: qtyAdded,
                                        price: parseFloat(product.variants[0].price),
                                    }
                                ]
                            };
                            window.uetq = window.uetq || [];
                            window.uetq.push('event', 'add_to_cart', bingEventData);
                            console.log(`bing add_to_cart data:`);
                            console.log(bingEventData);
                        }
                    }));
            })
        } catch (e) {
        }
    }

    async _addToCart(type, event, upsell = false) {
        if (!subscriptionFlow.currentVariantId || !subscriptionFlow.sellingPlanId) {
            notificationEle.updateNotification("Error", "Error while adding subscription to your cart", {
                type: "error",
                timeout: 2000
            });
            return false;
        }

        const items = [];
        let currentElement = event.currentTarget;
        currentElement?.classList.add("loading");
        const subscriptionSelected = document.querySelector('#productTabsContent .open input[name="subscription_handle"]').value;
        if(upsell === true){
          let dataSubscription = document.querySelector('[data-add-subscription]').closest('.product-popup').querySelector('[add-subscription-product]');
          let productForm = document.querySelector('div[data-subscription-upsell="true"]');
          dataSubscription.dataset.upsellValue = document.querySelector('.tablink.active .sub-plan.fw-medium.text-black').innerText;
          console.log(dataSubscription, 'datadata');
          subscriptionFlow.currentVariantId = productForm?.querySelector('[name="id"]')?.value;
          subscriptionFlow.sellingPlanId = productForm?.querySelector('[name="selling_plan"]')?.value;
          subscriptionFlow.productType = productForm?.querySelector('[data-product-type]')?.value || null;
          subscriptionFlow.preorder = productForm?.querySelector('[name="preorder"]')?.value || null;
          subscriptionFlow.originUrl = productForm?.querySelector('[name="origin_url"]')?.value || null;

          console.log(subscriptionFlow, 'flow');
        }

        const activeSubscriptions = document.querySelectorAll('.subscription-main.new-version [data-subscription-title].active');
        if (activeSubscriptions.length > 0) {
          activeSubscriptions.forEach(element => {
            const subscriptionTitle = element.getAttribute('data-subscription-title');
            const subscriptionTitleWords = subscriptionTitle.split(' ');
            const subscriptionLastWord = subscriptionTitleWords[subscriptionTitleWords.length - 1];
            const subscriptionLastWordLowerCase = subscriptionLastWord.toLowerCase();
            const subscriptionType = subscriptionLastWordLowerCase;
        });
        } else {
          console.log('No active subscriptions found');
        }

        
        if(type == 'direct'){
          let subscriptionData = {};

          try{
            let customerDetails = await window.rechargeHelper._getCustomerDetails();
            let allSubscriptions = customerDetails.include.subscriptions;
            allSubscriptions.sort((a, b) => {
                {
                    if (a.next_charge_scheduled_at == null) return 1;
                    if (b.next_charge_scheduled_at == null) return -1;
                    return new Date(a.next_charge_scheduled_at) - new Date(b.next_charge_scheduled_at);
                }
            });
            let activeSubscription = [];
            for (let order of allSubscriptions) {
                switch (order.status.toUpperCase()) {
                    case "ACTIVE":
                        activeSubscription.push(order);
                        break;
                    case "EXPIRED":
                    case "CANCELLED":
                        break;
                }
            }
            activeSubscription?.length > 0 
            ? subscriptionData['_activeSubscriber'] = 'true'
            : null;
          }
          catch{console.log('not logged in')}

          let randomNumber = Math.floor((Math.random() * 1000) + 1);
          subscriptionData['_box_identifier'] = `${randomNumber}`;
          subscriptionData['_is_pause'] = "false";



          if(this.isHackpack === 'true' || document.querySelector('.tablink.active').dataset.subscriptionproduct.includes('hack') === true) {
              subscriptionData['_box_sequence'] = window.subscriptions.default_hackpack_collection 
          }  
          else if(this.isCamp === 'true' || subscriptionSelected.includes('camp')) {
            subscriptionData['_camp_cl_box_sequence'] = window.subscriptions.default_boxes_collection;
          }
          else{
            subscriptionData['_box_sequence'] = window.subscriptions.default_boxes_collection;
          }
          // subscriptionData['subscription_sku'] = subscriptionFlow.subscriptionSku;

          
          if (window.subscriptions.enable_box_sequence) {
              if (window.subscriptionFlowCart) {
                  subscriptionData['_product_id'] = window.subscriptionFlowCart.productId;
                  subscriptionData['product_sku'] = window.subscriptionFlowCart.productSKU;
                  subscriptionData['_product_title'] = window.subscriptionFlowCart.productTitle;
                  subscriptionData['_box_sequence'] = window.subscriptionFlowCart.boxSequence;
              } else {

                  subscriptionData['_product_id'] = subscriptionFlow.productId;
                  subscriptionData['product_sku'] = subscriptionFlow.productSKU;
                  subscriptionData['_product_title'] = subscriptionFlow.productTitle;
                  subscriptionData['_box_sequence'] = subscriptionFlow.boxSequence;
              }
          } else {

            if(subscriptionFlow.productType !== null){
              subscriptionData['_product_type'] = subscriptionFlow.productType;
            }
              
              subscriptionData['_directorder'] = true;
              subscriptionData['_product_id'] = subscriptionFlow.productId;
              subscriptionData['product_sku'] = subscriptionFlow.productSKU;
              subscriptionData['_product_title'] = subscriptionFlow.productTitle;
              subscriptionData['_origin_url'] = subscriptionFlow.originUrl;
              subscriptionFlow.preorder ? 
              subscriptionData['_preorder'] = subscriptionFlow.preorder
              : null;
          }

          items.push({
              quantity: 1,
              id: parseInt(subscriptionFlow.currentVariantId),
              properties: subscriptionData,
              selling_plan: parseInt(subscriptionFlow.sellingPlanId)
          });
        }
        else{

          this.funnel.querySelectorAll("[data-subscriber-form]").forEach(ele => {
            let randomNumber = Math.floor((Math.random() * 1000) + 1);
            let formData = new FormData(ele);
            let subscriptionData = {};
            for (let [key, value] of formData) {
                let inputValue = value.trim();
                if (key === "fname") {
                    subscriptionData['nickname'] = value;
                } else if (key === "birthdate" && inputValue.length) {
                    subscriptionData['birthdate'] = value;
                }
            }
            subscriptionData['_box_identifier'] = `${randomNumber}`;
            subscriptionData['_is_pause'] = "false";
            if(this.isHackpack === 'true' || document.querySelector('.tablink.active').dataset.subscriptionproduct.includes('hack') === true) {
                subscriptionData['_box_sequence'] = window.subscriptions.default_hackpack_collection 
            }  
            else if(this.isCamp === 'true' || subscriptionSelected.includes('camp')) {
              subscriptionData['_camp_cl_box_sequence'] = window.subscriptions.default_boxes_collection;
            }
            else{
              subscriptionData['_box_sequence'] = window.subscriptions.default_boxes_collection;
            }
            // subscriptionData['subscription_sku'] = subscriptionFlow.subscriptionSku;

            
            if (window.subscriptions.enable_box_sequence) {
                if (window.subscriptionFlowCart) {
                    subscriptionData['_product_id'] = window.subscriptionFlowCart.productId;
                    subscriptionData['product_sku'] = window.subscriptionFlowCart.productSKU;
                    subscriptionData['_product_title'] = window.subscriptionFlowCart.productTitle;
                    subscriptionData['_box_sequence'] = window.subscriptionFlowCart.boxSequence;
                } else {

                    subscriptionData['_product_id'] = subscriptionFlow.productId;
                    subscriptionData['product_sku'] = subscriptionFlow.productSKU;
                    subscriptionData['_product_title'] = subscriptionFlow.productTitle;
                    subscriptionData['_box_sequence'] = subscriptionFlow.boxSequence;
                }
            } else {
              if(!subscriptionFlow.preorder){
                subscriptionData['_product_id'] = subscriptionFlow.productId;
                subscriptionData['product_sku'] = subscriptionFlow.productSKU;
                subscriptionData['_product_title'] = subscriptionFlow.productTitle;
              }
              if(subscriptionFlow.productType !== null){
                subscriptionData['_product_type'] = subscriptionFlow.productType;
              }
                subscriptionData['_origin_url'] = subscriptionFlow.originUrl;
                subscriptionFlow.preorder ? 
                subscriptionData['_preorder'] = subscriptionFlow.preorder
                : null;
            }

            items.push({
                quantity: 1,
                id: parseInt(subscriptionFlow.currentVariantId),
                properties: subscriptionData,
                selling_plan: parseInt(subscriptionFlow.sellingPlanId)
            });
        });
        }



        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({items: items}),
        })
            .then(response => {
                return response.json();
            })
            .then(async response => {
                if (response.items[0]) {
                    const item = response.items[0];
                    const props = item.properties;
                    const itemKey = `${props._product_id}-${props._box_identifier}`;
                    await Shopify.Cart.GiftWrap.processGiftWrappingForCartItem(0, true, null, true).then(() => {
                      if (type === "cart") {
                        window.location.href = "/cart";
                        currentElement.classList.remove("loading");
                      } else {
                        window.location.href = "/checkout";
                        currentElement.classList.remove("loading");
                      }
                    })
                }
            }).catch(e => {
            console.log(e);
            currentElement.classList.remove("loading");
        });
    }
}

new SubscriptionFunnel(document.querySelector("#data-subscription-funnel"));

window.subscriptionFunnelClass = SubscriptionFunnel;